export function getFileNameFromPath(path: string): string {
  const lastSlash = Math.max(path.lastIndexOf('/'), path.lastIndexOf('\\'))
  return lastSlash < 0 ? path : path.substring(lastSlash + 1)
}
